import React from "react";

export const EnvContext = React.createContext({
	isProd: true,
	app: null,
	api: null,
	setApp: (app) => {}
})
